<div [formGroup]="parentForm">
  <label class="spen-mod-select">
    <select
      class="select"
      data-cy="school-year"
      id="school-year-select"
      formControlName="school_year"
      (change)="onChangeSchoolOption($event.target.value)"
    >
      @if (optionsLoaded) {
        @for (year of schoolYears; track year) {
          <option [value]="year">{{ year }}年度</option>
        }
      }
    </select>
    <i class="fa fa-caret-down"></i>
  </label>
  <label class="spen-mod-select">
    <select
      class="select"
      data-cy="grade-id"
      id="grade-select"
      formControlName="grade_id"
      (change)="onChangeGradeOption($event.target.value)"
    >
      @if (optionsLoaded) {
        @for (grade of grades; track grade.id) {
          <option [value]="grade.id">{{ grade.school_stage_name }}{{ grade.name }}</option>
        }
      }
    </select>
    <i class="fa fa-caret-down"></i>
  </label>
  <label class="spen-mod-select">
    <select
      class="select"
      data-cy="class-id"
      id="class-select"
      formControlName="class_id"
      (change)="onChangeClassIdOption($event.target.value)"
    >
      @if (!classesFilterService.isLoading) {
        <option [ngValue]="null">すべての組</option>
        @for (class of classes; track class.id) {
          <option [value]="class.id">
            {{ class.classroom_name }}
          </option>
        }
      }
    </select>
    <i class="fa fa-caret-down"></i>
  </label>
</div>
